import React from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import MUITourneyTableHeader from "./Headers/TourneyTableHeader";
import TournamentTableBody from "./Bodys/TournamentTableBody";
import { RootState, GameData, GamelistModalDetails } from "types";

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    margin: "auto",
    marginBottom: "30px",
    maxWidth: "300px",
    padding: "30px",
  },
}));

// todo make better note card component
const Note: React.FC = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  const handleHostAccountClick = (): void => {
    navigate("./settings");
  };

  return (
    <Paper className={classes.paper} elevation={10}>
      <Typography component="div">
        <div>You have not found any private tournaments</div>
        <br />
        <div>
          If you host a game or know someone who does, consider creating a{" "}
          <a onClick={handleHostAccountClick} style={{ cursor: "pointer" }}>
            host account
          </a>
        </div>
      </Typography>
    </Paper>
  );
};

interface PrivateTournamentTableProps {
  setModalDets: (dets: GamelistModalDetails) => void;
  setGameData: (data: GameData) => void;
}

const PrivateTournamentTable: React.FC<PrivateTournamentTableProps> = (props) => {
  const privTourneyList = useSelector(
    (state: RootState): Record<string, GameData> | null => state.games.privateTourneyList,
  );

  if (!privTourneyList) {
    return <CircularProgress />;
  }
  
  if (Object.keys(privTourneyList).length > 0) {
    return (
      <TableContainer component={Paper}>
        <Table className="tablelist" aria-label="private tournament table">
          <MUITourneyTableHeader />
          <TournamentTableBody data={privTourneyList} {...props} />
        </Table>
      </TableContainer>
    );
  }
  
  return <Note />;
};

export default PrivateTournamentTable;
